<template>
  <div class="chemical-resistance-guide">
    <h1 class="h1--underline">
      {{ i18n.tv('headline', 'chemicalResistanceGuide') }}
    </h1>
    <h2> {{ i18n.tv('subHeadline', 'chemicalResistanceGuide') }} </h2>
    <div class="chemical-resistance-guide__text">
      <Markdown :text="i18n.tv('text', 'chemicalResistanceGuide')" />
    </div>
    <div class="chemical-resistance-guide__content">
      <CRGuideWrapper />
    </div>
    <div class="chemical-resistance-guide__footer">
      {{ i18n.tv('footer', 'chemicalResistanceGuide') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import CRGuideWrapper from '~/components/chemical-resistance-guide/CRGuideWrapper.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import useBreadcrumb from '~/composables/useBreadcrumb'
const i18n = useI18nExtended()
useBreadcrumb([
  {
    label: i18n.tv('title', 'chemicalResistanceGuide'),
    path: '/chemical-resistance-guide'
  }
])
</script>

<style lang="scss">
.chemical-resistance-guide {
  padding: 1.25rem 2rem 12.5rem;

  h1 {
    margin-top: 0;
  }

  h2 {
    margin: 1rem 0;
  }

  &__text {
    font-size: 0.875rem;
    font-weight: normal;
    margin-bottom: 1rem;
  }

  &__content {
    padding: 1rem 2rem;
  }

  &__footer {
    font-size: 0.938rem;
    font-weight: normal;
    border-top: .0625rem solid $color__primary;
    margin-bottom: 1rem;
    padding-top: 1rem;
    margin-top: 1rem;
  }
}
</style>
